import React from 'react'
import { Helmet } from 'react-helmet-async'
import { AuditLogsLayout } from '../../layouts'

const AuditLogsPage = (): React.ReactElement => (
  <React.Fragment>
    <Helmet>
      <title>Audit logs</title>
      <meta name="description" content="Audit logs page" />
    </Helmet>
    <AuditLogsLayout />
  </React.Fragment>
)

export default AuditLogsPage
